/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_EncodingInputs */



/**
* | output |
* | --- |
* | "This file is saved in a different character encoding. Save it as UTF-8 and upload it again." |
*
* @param {Embedding_Error_EncodingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_encoding = /** @type {((inputs?: Embedding_Error_EncodingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_EncodingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Datei ist in einer anderen Zeichenkodierung gespeichert. Speichern Sie sie als UTF-8 und laden Sie sie erneut hoch.")
	return /** @type {LocalizedString} */ ("This file is saved in a different character encoding. Save it as UTF-8 and upload it again.")
});